import React, { useState, useEffect } from 'react';
import { IDarkWebCompromise } from '../../models';
import { useTypedTranslation } from '../../hooks';
import { usersService } from '../../services';
import { genericErrorToast, passlyFormatDate, DATE_FORMAT, store } from '../../helpers';
import { SectionLoader } from '../../components';

interface IProps {
    userId: string;
}

export const DarkWebCompromises: React.SFC<IProps> = ({ userId }) => {
    const shellConfig: any = store.getState().basic.shellConfig;
    const [darkWebCompromises, setDarkWebCompromises] = useState<IDarkWebCompromise[]>([]);
    const [dwidCustomer, setDwidCustomer] = useState<boolean>(true);
    const [loading, setLoading] = useState<boolean>(true);
    const [hasSalesForceId, setHasSalesForceId] = useState<boolean>(true);

    const { translation } = useTypedTranslation();

    useEffect(() => {
        if (loading) {
            if (shellConfig.intercom.salesforceId && shellConfig.intercom.salesforceId?.trim() !== '') {
                setHasSalesForceId(true);
                usersService.getDarkWebCompromises(userId, handleDarkWebCompromisesSuccess, genericErrorToast);
            }
            else {
                setLoading(false);
                setHasSalesForceId(false);
            }
        }
    }, [loading]);

    const handleDarkWebCompromisesSuccess = (response: any): void => {
        setLoading(false);
        setDarkWebCompromises(response.data.DarkWebCompromiseDTOs);
        setDwidCustomer(response.data.DwidCustomer);
    };

    const passwordHitReplacer = (origString: string): string => {
        const firstPart = origString.substr(0, 4);

        const newString = firstPart + '*'.repeat(8);
        return newString;
    };

    return (
        <>
            <div className='detailPage__section'>
                <div className='detailPage__section-head'>{translation('DARK_WEB_COMPROMISES')}</div>

                <div className='detailPage__section-content'>
                    {loading && <SectionLoader />}
                    {!hasSalesForceId ?
                        <>
                            <div dangerouslySetInnerHTML={{ __html: translation('DARK_WEB_NOT_A_CUSTOMER') }} />
                        </>
                        :
                        <>
                            {darkWebCompromises && darkWebCompromises.length > 0 ? (
                                <div>
                                    {darkWebCompromises.map((item: IDarkWebCompromise, index: number) => (
                                        <div key={index}>
                                            {
                                                <div className='detailPage__section-content-dark-web-compromises__wrapper'>
                                                    <dl className='detailPage__section-content-dark-web-compromises'>
                                                        <div className='detailPage__section-content-dark-web-compromises__container'>
                                                            <dt className='detailPage__list--primary-label'>{translation('DATE_ADDED')}</dt>
                                                            <dd className='detailPage__list--secondary-label'>{passlyFormatDate(item.Created, DATE_FORMAT)}</dd>
                                                        </div>
                                                        <div className='detailPage__section-content-dark-web-compromises__container'>
                                                            <dt className='detailPage__list--primary-label'>{translation('DATE_FOUND')}</dt>
                                                            <dd className='detailPage__list--secondary-label'>{passlyFormatDate(item.Found, DATE_FORMAT)}</dd>
                                                        </div>
                                                        <div className='detailPage__section-content-dark-web-compromises__container'>
                                                            <dt className='detailPage__list--primary-label'>{translation('PASSWORD_HIT')}</dt>
                                                            <dd className='detailPage__list--secondary-label'>
                                                                {item.PasswordHit ? passwordHitReplacer(item.PasswordHit) : '-'}
                                                            </dd>
                                                        </div>
                                                    </dl>
                                                    <dl className='detailPage__section-content-dark-web-compromises'>
                                                        <div className='detailPage__section-content-dark-web-compromises__container'>
                                                            <dt className='detailPage__list--primary-label'>{translation('COMPROMISE_TYPE')}</dt>
                                                            <dd className='detailPage__list--secondary-label'>{item.CompromiseType}</dd>
                                                        </div>

                                                        <div className='detailPage__section-content-dark-web-compromises__container'>
                                                            <dt className='detailPage__list--primary-label'>{translation('SOURCE')}</dt>
                                                            <dd className='detailPage__list--secondary-label'>{item.Source}</dd>
                                                        </div>

                                                        <div className='detailPage__section-content-dark-web-compromises__container'>
                                                            <dt className='detailPage__list--primary-label'>{translation('ORIGIN')}</dt>
                                                            <dd className='detailPage__list--secondary-label'>{item.Origin}</dd>
                                                        </div>
                                                    </dl>
                                                    <dl className='detailPage__section-content-dark-web-compromises'>
                                                        <div className='detailPage__section-content-dark-web-compromises__container'>
                                                            <dt className='detailPage__list--primary-label'>{translation('PII_FLAG')}</dt>
                                                            <dd className='detailPage__list--secondary-label'>{item.PIIFlag}</dd>
                                                        </div>
                                                    </dl>
                                                </div>
                                            }
                                        </div>
                                    ))}
                                </div>
                            ) :
                                (
                                    <>
                                        {!loading &&
                                            <>
                                                {!dwidCustomer ?
                                                    <div dangerouslySetInnerHTML={{ __html: translation('DARK_WEB_NOT_A_CUSTOMER') }} />
                                                    :
                                                    <div>{translation('DARK_WEB_COMPROMISES_NO_DATA')}</div>
                                                }
                                            </>
                                        }
                                    </>
                                )}</>
                    }

                </div>
            </div>
        </>
    );
};
